import { IAppointmentManagementListModel } from "@common/models";
import { AppointmentsStore } from '@customer/stores';
import { observer } from 'mobx-react';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { AppointmentGroup } from '.';

interface IAppointmentListProps {
    store: AppointmentsStore;
    apptList: IAppointmentManagementListModel;
    listName: string
}

export const AppointmentList = observer(({ store, apptList, listName }: IAppointmentListProps) => {
    return (
        <>
            <Row>
                <Col>
                    {
                        apptList.groups
                            .slice()
                            .sort((a, b) => a.sortOrder - b.sortOrder)
                            .map((group, index) => (
                                <AppointmentGroup store={store} group={group} key={'group_' + index} groupId={`${listName}_group_${index}`} />
                            ))
                    }
                </Col>
            </Row>
        </>
    );
});
